// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DatabaseOutlinedSvg from "@ant-design/icons-svg/es/asn/DatabaseOutlined";
import AntdIcon from '../components/AntdIcon';

var DatabaseOutlined = function DatabaseOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DatabaseOutlinedSvg
  }));
};

DatabaseOutlined.displayName = 'DatabaseOutlined';
export default React.forwardRef(DatabaseOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/DatabaseOutlined.js
// module id = 913
// module chunks = 0